import {
  Flex,
  Button,
  Drawer,
  DrawerBody,
  DrawerOverlay,
  DrawerContent,
  useColorModeValue,
  Stack,
  useColorMode,
  IconButton,
  useMediaQuery,
  useDisclosure,
  HStack,
  Link,
  Image
} from "@chakra-ui/react";
import { MoonIcon, SunIcon, HamburgerIcon } from "@chakra-ui/icons";
import { useState, useContext } from "react";
import ProfileArray from "./ProfileArray";
import { TranslatedTextContext } from "../App.js";

const TbIcons = require("react-icons/tb");

export default function Nav({ color, setLanguage }) {
  const profile = ProfileArray();
  const translatedText = useContext(TranslatedTextContext);
  const colors = {
    "blue": "#3182CE",
    "cyan": "#00B5D8",
    "gray": "#718096",
    "green": "#38A169",
    "orange": "#DD6B20",
    "pink": "#D53F8C",
    "purple": "#805AD5",
    "red": "#E53E3E",
    "teal": "#319795",
    "yellow": "#D69E2E"
  };
  const [scroll, setScroll] = useState(false);
  const { colorMode, toggleColorMode } = useColorMode();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [isLargerThanMD] = useMediaQuery("(min-width: 48em)");
  const scrollToHero = () => {
    const heroSection = document.querySelector("#hero");
    heroSection.scrollIntoView({ behavior: "smooth" });
  };
  const scrollToAbout = () => {
    const aboutSection = document.querySelector("#about");
    aboutSection.scrollIntoView({ behavior: "smooth" });
  };
  const scrollToExperience = () => {
    const experienceSection = document.querySelector("#experience");
    experienceSection.scrollIntoView({ behavior: "smooth" });
  };
  const scrollToProjects = () => {
    const projectsSection = document.querySelector("#projects");
    projectsSection.scrollIntoView({ behavior: "smooth" });
  };
  const scrollToContact = () => {
    const contactSection = document.querySelector("#contact");
    contactSection.scrollIntoView({ behavior: "smooth" });
  };
  const changeScroll = () =>
    document.body.scrollTop > 80 || document.documentElement.scrollTop > 80
      ? setScroll(true)
      : setScroll(false);

  window.addEventListener("scroll", changeScroll);

  const TbLetterComponents = [];

  for (let i = 0; i < profile.logo.length; i++) {
    const letter = profile.logo[i];
    const component = TbIcons[`TbLetter${letter}`];
    TbLetterComponents.push(component);
  }

  return (
    <>
      <Flex
        bg={useColorModeValue("gray.100", "gray.900")}
        px={4}
        h={16}
        boxShadow={scroll ? "base" : "none"}
        zIndex="sticky"
        position="fixed"
        as="header"
        alignItems={"center"}
        justifyContent={"space-between"}
        w="100%"
      >
        {/* <Image src='../../assets/logo512.png' alt='Logo' boxSize='50px' /> */}
        <Link onClick={scrollToHero}>
          <HStack>
            {TbLetterComponents.map((Component, index) => (
              <Component key={index} color={colors[color]} />
            ))}
          </HStack>
        </Link>

        <Flex alignItems={"center"}>
          <Stack direction={"row"} spacing={7}>
            {isLargerThanMD ? (
              <>
                <Button variant="ghost" onClick={scrollToAbout}>
                  {translatedText.aboutUs.name}
                </Button>
                <Button variant="ghost" onClick={scrollToExperience}>
                  {translatedText.team.name}
                </Button>
                <Button variant="ghost" onClick={scrollToProjects}>
                  {translatedText.downloads.name}
                </Button>
                <Button variant="ghost" onClick={scrollToContact}>
                  {translatedText.contact.name}
                </Button>
                <Button onClick={() => {
                  setLanguage((lang) => (lang === "en" ? "ur" : "en"));
                }}>
                  {translatedText.selectedLanguage === "english"
                    ? "UR"
                    : "ENG"}
                </Button>
              </>
            ) : (
              <></>
            )}
            <Button onClick={toggleColorMode}>
              {colorMode === "light" ? <MoonIcon /> : <SunIcon />}
            </Button>

            {isLargerThanMD ? (
              <></>
            ) : (
              <>
                <Button
                  as={IconButton}
                  icon={<HamburgerIcon />}
                  onClick={onOpen}
                ></Button>
                <Drawer placement="top" onClose={onClose} isOpen={isOpen}>
                  <DrawerOverlay />
                  <DrawerContent>
                    <DrawerBody>
                      <Button variant="ghost" onClick={scrollToAbout}>
                        {translatedText.aboutUs.name}
                      </Button>
                      <Button variant="ghost" onClick={scrollToExperience}>
                        {translatedText.team.name}
                      </Button>
                      <Button variant="ghost" onClick={scrollToProjects}>
                        {translatedText.downloads.name}
                      </Button>
                      <Button variant="ghost" onClick={scrollToContact}>
                        {translatedText.contact.name}
                      </Button>
                      <Button variant="ghost" onClick={() => {
                        setLanguage((lang) => (lang === "en" ? "ur" : "en"));
                      }}>
                        {translatedText.selectedLanguage === "english"
                          ? "UR"
                          : "ENG"}
                      </Button>
                    </DrawerBody>
                  </DrawerContent>
                </Drawer>
              </>
            )}
          </Stack>
        </Flex>
      </Flex>
    </>
  );
}
